import React from 'react';
import { Radio, Input, InputNumber, Row, Col, message, Select, DatePicker } from 'antd'
import { InputType, WidthType } from './input-const';
import moment from 'moment';

const RadioGroup = Radio.Group;

//最小宽度
const minWidth = 1;

/*
 * @Description:日期时间控件
 * @Author: zengweijin
 * @LastEditors: zengweijin
 * @Date: 2019-04-09 09:24:19
 * @LastEditTime: 2019-04-29 16:35:49
 */
class SettingDateTimePicker extends React.Component {

  constructor(props) {
    super(props);
    this.state = {
      feature: '', //原参数json字符串
      width: minWidth, //设置的宽度值，初始为最小宽度值
      featureParams: {
        name: '日期时间控件',
        type: InputType.DATETIMEPICKER, //控件类型，必须有此属性，用于渲染时期判断控件类型
        widthType: WidthType.DEFAULT, //宽度类型：自适应'default'、百分比'relative'、固定值'fixed'
        widthStr: '', //input宽度值
        required: false, //是否必须
        defaultValue: '', //默认值
        format: 'YYYY-MM-DD HH:mm:ss',
        validationValueType: 'object'
      },
    }
  }

  static defaultProps = {
    initFeature: ''
  }

  //在渲染前调用,可在此最后一次初始化组件状态
  componentWillMount() {
    //将输入控件配置参数设置到状态中
    if (this.props.initFeature) {
      try {
        let initFeature = JSON.parse(this.props.initFeature);
        if (initFeature.type == InputType.DATETIMEPICKER) {
          let { widthType, widthStr = '', required = false,
            defaultValue = '',format } = initFeature;
          let width = '';

          if (widthType == WidthType.RELATIVE) {
            width = widthStr.replace('%', '');
          } else if (widthType == WidthType.FIXED) {
            width = widthStr.replace('px', '');
          }
          const fp = { ...this.state.featureParams };
          fp.widthType = widthType;
          fp.widthStr = widthStr;
          fp.required = required;
          fp.defaultValue = defaultValue;
          fp.format = format;
          this.setState({
            feature: this.props.initFeature,
            width: width,
            featureParams: fp
          });
        }

      } catch (e) {
        message.error('解析控件配置参数出错！');
      }
    } else {
      try {
        let feature = JSON.stringify(this.state.featureParams);
        this.setState({
          feature: feature
        });
      } catch (e) {
        console.log(e);
        message.error('生成控件配置参数出错！');
      }
    }

  }

  //供父组件获取feature
  getFeature = () => {
    return this.state.feature;
  }

  //切换宽度类型radio时回调，清空之前的值
  handleWidthRadioChange = (e) => {
    let widthType = e.target.value;

    const fp = { ...this.state.featureParams };
    fp.widthType = widthType;
    fp.widthStr = '';

    this.setState({ width: '', featureParams: fp });
    this.createFeature(fp);
  }

  //宽度值改变的时候，同步更新状态参数
  handleWidthChange = (value) => {
    let widthStr;
    let widthType = this.state.featureParams.widthType;

    if (widthType == WidthType.RELATIVE) {
      widthStr = value + '%';
    } else if (widthType == WidthType.FIXED) {
      widthStr = value + 'px';
    } else {
      widthStr = '';
    }

    const fp = { ...this.state.featureParams };
    fp.widthStr = widthStr;

    this.setState({ width: value, featureParams: fp });
    this.createFeature(fp);
  }

  //是否必填
  handleRequiredRadioChange = (e) => {
    let required = e.target.value;

    const fp = { ...this.state.featureParams };
    fp.required = required;

    this.setState({ featureParams: fp });
    this.createFeature(fp);
  }
  //当输入默认值改变时
  handleDefaultValueChange = (date,dateStr) => {
    let defaultValue = dateStr;
    const fp = { ...this.state.featureParams };
    fp.defaultValue = defaultValue;
    this.setState({ featureParams: fp });
    this.createFeature(fp);
  }
  // 日期时间格式
  handleFormatChange = (value) => {
    let format = value;
    const fp = { ...this.state.featureParams };
    fp.format = format;
    this.setState({ featureParams: fp });
    this.createFeature(fp);
  }

  //生成feature参数json字符串
  createFeature = (featureParams) => {

    try {
      let feature = JSON.stringify(featureParams);
      this.setState({
        feature: feature
      });
      this.props.onChange(feature);
    } catch (e) {
      console.log(e);
      message.error('生成控件配置参数出错！');
    }
  }

  render() {

    let width = this.state.width;
    let { widthType, required, defaultValue, showTime, format } = this.state.featureParams;

    return (
      <div id="input-setting-div">
        <Row type="flex">
          <Col>
            <div style={{ margin: "16px 0" }}>宽度</div>
          </Col>
        </Row>
        <Row type="flex">
          <Col>
            <RadioGroup onChange={this.handleWidthRadioChange} name="widthradiogroup"
              value={widthType}>
              <Radio value={WidthType.DEFAULT}>
                自适应
                            </Radio>
              <Radio value={WidthType.RELATIVE}>
                百分比
                            </Radio>
              <Radio value={WidthType.FIXED}>
                固定宽度
                            </Radio>
            </RadioGroup>
          </Col>
          <Col>
            {
              widthType == WidthType.RELATIVE ?
                <InputNumber size="small"
                  min={minWidth}
                  formatter={value => `${value}%`}
                  parser={value => value.replace('%', '')}
                  onChange={this.handleWidthChange}
                  value={width} />
                : (
                  widthType == WidthType.FIXED ?
                    <InputNumber size="small"
                      min={minWidth}
                      formatter={value => `${value}px`}
                      parser={value => value.replace('px', '')}
                      onChange={this.handleWidthChange}
                      value={width} />
                    : null
                )
            }
          </Col>
        </Row>
       {/*  <Row type="flex">
          <Col>
            <div style={{ margin: "16px 0" }}>是否必填</div>
          </Col>
        </Row>
        <Row type="flex">
          <Col>
            <RadioGroup onChange={this.handleRequiredRadioChange} name="requiredradiogroup"
              value={required}>
              <Radio value={false}>
                非必填
                            </Radio>
              <Radio value={true}>
                必填
                            </Radio>
            </RadioGroup>
          </Col>
        </Row> */}
        <Row type="flex">
          <Col span={24}>
            <div style={{ margin: "16px 0" }}>默认值 | 日期时间格式</div>
          </Col>
        </Row>
        <Row type="flex">
          <Col span={12}>
            <DatePicker showTime placeholder="请输入默认值" value={defaultValue?moment(new Date(defaultValue), 'yyyy-MM-dd HH:mm:ss'):undefined} onChange={this.handleDefaultValueChange}  format={format} />
          </Col>
          <Col span={12}>
            <Select dropdownMatchSelectWidth={false} onChange={this.handleFormatChange} value={format}>
              <Select.Option value='YYYY-MM-DD HH:mm:ss'>YYYY-MM-DD HH:mm:ss</Select.Option>
              <Select.Option value='YYYY-MM-DD HH:mm'>YYYY-MM-DD HH:mm</Select.Option>
              <Select.Option value='YYYY-MM-DD HH'>YYYY-MM-DD HH</Select.Option>
            </Select>
          </Col>
        </Row>
      </div>
    )
  }
}

export default SettingDateTimePicker;



// WEBPACK FOOTER //
// ./components/common/NHInputPicker/setting-datetimepicker.js